export default "__VITE_ASSET__AfQpWxuQ__"